import Cookies from "js-cookie";
import arigatouGozaimasu from "../../audio/v2/arigatou gozaimasu 2.wav";
import arigatou from "../../audio/v2/arigatou.wav";
import maidOkaeri from "../../audio/v2/maid okaeri.wav";
import ohayouGozaimasu from "../../audio/v2/ohayou gozaimasu.wav";
import okaeri from "../../audio/v2/okaeri.wav";
import okaerinasai from "../../audio/v2/okaerinasai.wav";
import okaerinasaimase from "../../audio/v2/okaerinasaimase.wav";

export enum VoiceLine {
	Arigatou,
	ArigatouGozaimasu,
	OhayouGozaimasu,
	Okaeri,
	Okaerinasai,
	Okaerinasaimase,
	MaidOkaeri,
}

export enum VoiceLine2 {
	Greeting = 1,
	Thanks = 2,
	Baka = 3,
	Returned = 4,
	Idle = 5,
	Affection = 6,
	Warning = 7,
	Annoyed = 8,
	Flustered = 9,
	Farewell = 10,
}

// F:\Program Files\w-okada voice changer https://www.youtube.com/watch?v=_JXbvSTGPoo
// Yuko Yoshida Shamiko voice https://discord.com/channels/1159260121998827560/1199544823175200839/1199544823175200839 https://huggingface.co/sxndypz/rvc-v2-models/resolve/main/shamikov2.zip
// Use audacity to make robotic https://www.youtube.com/watch?v=9cJSn8utwgY


// F:\Programming\Maidchan Voice\tts.py
// https://aihubdocs.github.io/en/vocal-isolation--datasets/datasets/

const getAudioFromLine = (line: VoiceLine) => {
	const volume = Number(Cookies.get("videoVolume") ?? 0.1);
	switch (line) {
		case VoiceLine.Arigatou:
			return { audio: arigatou, volume };
		case VoiceLine.ArigatouGozaimasu:
			return { audio: arigatouGozaimasu, volume };
		case VoiceLine.OhayouGozaimasu:
			return { audio: ohayouGozaimasu, volume };
		case VoiceLine.Okaeri:
			return { audio: okaeri, volume };
		case VoiceLine.Okaerinasai:
			return { audio: okaerinasai, volume };
		case VoiceLine.Okaerinasaimase:
			return { audio: okaerinasaimase, volume };
		case VoiceLine.MaidOkaeri:
			return { audio: maidOkaeri, volume };
		default:
			return null;
	}
}

const getAudioFromLine2 = (line: VoiceLine2) => {
	const volume = Number(Cookies.get("videoVolume") ?? 0.1);
	return { audio: `/chat/voice?voiceLine=${line}&timezoneOffset=${new Date().getTimezoneOffset()}&cache=${Date.now()}`, volume };
}

export const sayLine = (line: VoiceLine2, action: () => void, onend: () => void) => {
	const params = getAudioFromLine2(line);
	if (!params) { return; }
	const audio = new Audio(params.audio);
	// audio.load();
	audio.onplaying = () => {
		// audio.play();
		action();
	};
	audio.onended = () => {
		onend();
	}
	audio.volume = params.volume;

	audio.addEventListener("canplaythrough", () => {
		audio.play().catch(e => {
			window.addEventListener("click", () => {
				audio.play();
			}, { once: true });
		});
	});
	// try {
	// 	audio.play();
	// } catch (ex) {
	// 	console.error(ex);
	// 	onError();
	// }
}

// export const useMaidchanVoice = () => {
// 	const [line, setLine] = useState<VoiceLine>(VoiceLine.Arigatou);
// 	const [play, setPlay] = useState(false);
// 	const [loaded, setLoaded] = useState(false);
// 	const audio = useRef<HTMLAudioElement>(null);

// 	const source = useMemo(() => {
		
// 	}, [line]);

// 	const sayLine = useCallback((voiceLine: VoiceLine) => {
// 		console.log(voiceLine);

		

// 		if (line !== voiceLine) {
// 			setLoaded(false);
// 			setLine(line);
// 		}
// 		setPlay(true);
// 	}, [line]);

// 	useEffect(() => {
// 		console.log(audio.current, play, loaded);
// 		if (!audio.current || !play || !loaded) { return; }
// 		audio.current.volume = 0.1;
// 		audio.current.play();
// 		setPlay(false);
// 	}, [loaded, play]);

// 	return {
// 		// audioElement: <audio autoPlay={false} src={source} onLoad={() => {setLoaded(true);}} ref={audio} />,
// 		sayLine,
// 	}
// }